const com8A = {
	code: "8A",
	length: { min: 1, max: 1 },
	payload: [
		{ name: "código", type: "bytes", length: 1, description: "Código de configuración (1 byte).", pad: "00" },
		{ name: "servidor1", type: "string", description: "Dirección IP/URL del servidor NTP 1. '-1' permite mandar el mensaje sin modificar la dirección IP del servidor.", special: ["-1"] },
		{ name: "servidor2", type: "string", description: "Dirección IP/URL del servidor NTP 2. '-1' permite mandar el mensaje sin modificar la dirección IP del servidor.", special: ["-1"] },
		{ name: "servidor3", type: "string", description: "Dirección IP/URL del servidor NTP 3. '-1' permite mandar el mensaje sin modificar la dirección IP del servidor.", special: ["-1"] },
		{ name: "servidor4", type: "string", description: "Dirección IP/URL del servidor NTP 4. '-1' permite mandar el mensaje sin modificar la dirección IP del servidor.", special: ["-1"] },
	],
};

export default com8A;